import { render } from "./FounderDetails.vue?vue&type=template&id=514e4b37&scoped=true"
const script = {}

import "./FounderDetails.vue?vue&type=style&index=0&id=514e4b37&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-514e4b37"

export default script